<!--マイカー通勤･業務使用申請確認-->
<template>
  <div>
    <div class="all_area_i0013">
      <div class="el-detail_i0013">
        <el-row style="padding-bottom: 10px;">
          <table class="i0013-table table-label">
            <tr>
              <!--氏名-->
              <td class="i0013-form-label">{{$t('MODULE.I0013_LBL_NAME')}}</td>
              <td class="i0013-form-value">{{this.name}}</td>
            </tr>
            <tr>
              <!--スタッフCD-->
              <td class="i0013-form-label">{{$t('MODULE.I0013_LBL_NUMBER')}}</td>
              <td class="i0013-form-value">{{this.userCd}}</td>
            </tr>
            <tr>
              <!--営業所-->
              <td class="i0013-form-label">{{$t('MODULE.I0013_LBL_ADDRESS')}}</td>
              <td class="i0013-form-value">{{this.address}}</td>
            </tr>
          </table>
          <!--全ての項目を入力・申請後に確認ができてからの許可となります。-->
          <div class="table-label" style="color:red;padding-left: 10px;">{{$t('MODULE.I0013_LBL_TEXT_A')}}</div>
          <!--【必要な書類】（このアプリにて撮影します）-->
          <div class="table-label" style="margin-top: 3px;padding-left: 10px;">{{$t('MODULE.I0013_LBL_TEXT_B')}}</div>
          <!--1．車検証の写し-->
          <div class="table-label" style="margin-top: 3px;padding-left: 10px;">{{$t('MODULE.I0013_LBL_TEXT_C')}}</div>
          <!--2．任意保険証の写し-->
          <div class="table-label" style="margin-top: 3px;padding-left: 10px;">{{$t('MODULE.I0013_LBL_TEXT_D')}}</div>
          <!--3．運転免許証の写し（表面・裏面）-->
          <div class="table-label" style="margin-top: 3px;padding-left: 10px;">{{$t('MODULE.I0013_LBL_TEXT_E')}}</div>
        </el-row>
        <!--通勤許可申請条件への承諾-->
        <el-row>
          <div class="table-header" style="text-align:left;">
            <!--通勤許可申請条件への承諾-->
            <span>{{$t('MODULE.I0013_LBL_TEXT_F')}}</span>
          </div>
          <table class="i0013-table table-label">
            <tr>
              <td style="border:1px; border-right-style:none;text-align: left;background: #fafafa;width:45%">{{$t('MODULE.I0013_LBL_TEXT_G')}}<br />{{$t('MODULE.I0013_LBL_TEXT_H')}}</td>
              <td style="border:1px; border-left-style:none;text-align: left;background: #fafafa;">
                <el-radio v-model="radioValue" label="1">
                  <span class="table-label">{{$t('MODULE.I0013_BTN_YES')}}</span>
                </el-radio>
                <el-radio v-model="radioValue" label="2">
                  <span class="table-label">{{$t('MODULE.I0013_BTN_NO')}}</span>
                </el-radio>
              </td>
            </tr>
          </table>
        </el-row>
        <!--誓約-->
        <el-row>
          <div class="table-header" style="text-align:left;">
            <!--誓約-->
            <span>{{$t('MODULE.I0013_LBL_TEXT_P')}}</span>
          </div>
          <table class="i0013-table table-label">
            <tr class="i0013-form-value1">{{$t('MODULE.I0013_LBL_TEXT_I')}}</tr>
            <tr class="i0013-form-value1">{{$t('MODULE.I0013_LBL_TEXT_J')}}</tr>
          </table>
        </el-row>
      </div>
      <div>
        <!--上記内容に同意します-->
        <el-checkbox v-model="checkboxValue" style="margin-left:5px;margin-top:10px">
          <div class="table-label">{{$t('MODULE.I0013_LBL_TEXT_O')}}</div>
        </el-checkbox>
      </div>
      <div>
        <el-row style="text-align:center;">
          <!--入力画面-->
          <el-button class="css-btn css-button" type="primary" style="margin-top: 8px;font-size: 13px;width:26%" @click="inputPicuture_click" :disabled="!(this.radioValue == 1 && this.checkboxValue)">{{$t('MODULE.I0013_BTN_INPUT_PICTURE')}}</el-button>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
let url = require('@/../config/sysConfig')
import css from "@/statics/css"
import * as amsApi from "../api/i_0013"
export default {
  mixins: [css],
  components: {
  },
  data() {
    return {
      //氏名
      name: '',
      //スタッフCD
      userCd: '',
      //営業所
      address: '',
      //承諾
      radioValue: '',
      //同意
      checkboxValue: false,
    }
  },
  // 初期化
  created() {
    //氏名
    this.name = JSON.parse(localStorage.getItem('userInfo')).userName;
    //スタッフCD
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    //営業所
    this.address = JSON.parse(localStorage.getItem('userInfo')).salesOfficeAbbreviation;
    //承諾
    this.radioValue = "";
    //同意
    this.checkboxValue = false;
    ///書類の期限切れの有無を取得する。
    this.mycarPeriodCheck();
  },
  methods: {
    // 入力画面
    inputPicuture_click() {
      // //マイカー使用有無をチェック
      // //API「マイカー使用有無検索」を呼び出す。
      // amsApi.i_0013_mycarusecheck(this.userCd).then(res => {
      //   if (res.code == 204) {
      //     if (res.items.myCarUse == 1) {
      //       //マイカー使用有無が「1：有」の場合、処理を続け
      //       //API「スタッフ申請確認ログ保存」を呼び出す。
      //       var params = {
      //         stfConfirmType: "3",//3（マイカー通勤）
      //         stfConfirmResult: "1",//同意
      //         stfConfirmUserCd: JSON.parse(localStorage.getItem('userInfo')).userCd,
      //       };
      //       amsApi.i_0013_confirmlog(params, this.userCd).then(res => {
      //         if (res.code == 202) {
      //           //マイカー出勤申請画面へ遷移
      //           this.$router.push({ path: url.routerUrl_I0008 });
      //         } else if (res.code == 311) {
      //           this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
      //         }
      //       });
      //     } else {
      //       //マイカー使用有無が上記以外の場合、エラーメッセージ「マイカー使用無のため、入力画面へ遷移できません。」
      //       this.$message.error({ message: this.$t('COMMON.MSG_MYCAR_USE_CHE'), showClose: true });
      //     }
      //   } else if (res.code == 300) {
      //     this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true });
      //   }
      // });

      //API「スタッフ申請確認ログ保存」を呼び出す。
      var params = {
        stfConfirmType: "3",//3（マイカー通勤）
        stfConfirmResult: "1",//同意
        stfConfirmUserCd: JSON.parse(localStorage.getItem('userInfo')).userCd,
      };
      amsApi.i_0013_confirmlog(params, this.userCd).then(res => {
        if (res.code == 202) {
          //マイカー出勤申請画面へ遷移
          this.$router.push({ path: url.routerUrl_I0008 });
        } else if (res.code == 311) {
          this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });//保存失敗
        }
      });
    },
    //書類の期限切れの有無を取得する。
    async mycarPeriodCheck() {
      await amsApi.menuStateManagerGet(this.userCd).then(res => {
        if (res.code == 204) {
          //レスポンス．マイカー通勤申請(期間切れ)＝0の場合、警告メッセージ[（辞書ID：MSG_MYCAR_PERIOD_CHECK）を表示する。
          var i0008Expired = res.items.menuState[0].i0008Expired;
          var i0008Used = res.items.menuState[0].i0008Used;
          if (i0008Expired == 0 && i0008Used != 2) {
            this.$message.warning({ message: this.$t('COMMON.MSG_MYCAR_PERIOD_CHECK'), showClose: true });
          }
        }
      }).catch(error => {

      });
    }
  },
}
</script>
<style scope>
/*panel下全部区域*/
.all_area_i0013 {
  margin-left: 0px;
  margin-top: 5px;
}
/*下半部整体div样式*/
.el-detail_i0013 {
  width: 100%;
  height: 100%;
}
.i0013-table.el-table td {
  padding: 0px 0;
}
/* 表格边框、字体样式 */
.i0013-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0013-table,
.i0013-table tr td {
  border: 1px solid #ccc;
}
/* 表格内边距 */
.i0013-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.i0013-form-label {
  text-align: center;
  width: 110px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.i0013-form-value {
  text-align: center;
  background: #fafafa;
}
.i0013-form-value1 {
  text-align: left;
  background: #fafafa;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0013.vue